import { createFileRoute } from "@tanstack/react-router";

import BeginSecurityCheck from "@/features/security/BeginSecurityCheck";

export const Route = createFileRoute("/_auth/security/begin-security-check")({
  component: BeginSecurityCheck,
});
